import PropTypes from 'prop-types';
import React, { Component } from 'react';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import currencyHelper from 'helpers/currencyHelper';
import UserWalletsCreateForm from './UserWalletsCreateForm';
import Actions from 'components/ui/general/Actions';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import Title from 'components/ui/general/Title';
import translate from 'components/hoc/translate';
import { fetchUser } from 'store/actions/users/fetchUsers';
import fetchResourceById from 'components/hoc/fetchResourceById';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { showNotification } from 'store/actions/uiActions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import utils from 'helpers/utils';
import LoadingCard from 'components/loading/LoadingCard';

class UserWalletsCreateContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currencies: currencyHelper.currencyChoices,
        };
    }

    componentDidMount() {
        this.fetchUserWallets();
    }

    fetchUserWallets = async () => {
        const { id } = this.props;
        const { currencies } = this.state;

        const response = await apiClient.read(`${ config.getApiBaseUrl() }/users/${ id }/wallets`);

        const walletsCurrencies = response.map((wallet) => {
            return wallet.currency;
        });

        const filteredCurrencies = currencies.filter((currency) => {
            return !walletsCurrencies.includes(currency.code);
        });

        this.setState({
            currencies: filteredCurrencies,
        });
    }

    handleSubmitForm = async (formData) => {
        const {
            data: {
                email,
                id,
            },
            history,
            showErroNotification,
        } = this.props;

        const payload = {
            ...formData,
            email,
        };

        try {
            await apiClient.create(`${ config.getApiBaseUrl() }/wallets`, payload);
            history.push(`/users/${ id }/show`);
        } catch (error) {
            showErroNotification(error.message);
        }
    }

    render() {
        const { currencies } = this.state;
        const { data, resourceFetchLoading, translate } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        const fullName = utils.fullName(data.first_name, data.last_name);
        const userUrl = `/users/${ data && data.id }/show`;

        const breadcrumbs = [
            {
                label: translate('resources.users.title'),
                link: '/users',
            },
            {
                label: fullName,
                link: userUrl,
            },
            {
                label: translate('resources.discount_codes.components.type.choices.wallet'),
            },
            {
                label: translate('actions.create'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('actions.create') } />

                    <Actions>
                        <ListButton url={ userUrl } />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <UserWalletsCreateForm
                            form='wallets_create'
                            currencies={ currencies }
                            handleSubmitForm={ this.handleSubmitForm }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

UserWalletsCreateContainer.propTypes = {
    id: PropTypes.number.isRequired,
    data: PropTypes.shape({
        id: PropTypes.number,
        email: PropTypes.string,
        first_name: PropTypes.string,
        last_name: PropTypes.string,
    }),
    history: PropTypes.shape({
        push: PropTypes.func,
    }),
    resourceFetchLoading: PropTypes.bool,
    showErroNotification: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const fetchValues = {
    resource: 'users',
    action: fetchUser,
};

const mapDispatchToProps = (dispatch) => {
    return {
        showErroNotification: (message) => {
            dispatch(showNotification(message, 'warning'));
        },
    };
};

const enhance = compose(
    connect(null, mapDispatchToProps),
    fetchResourceById(fetchValues),
    translate,
);

export default enhance(UserWalletsCreateContainer);


// WEBPACK FOOTER //
// ./src/pages/users/wallets/create/UserWalletsCreateContainer.js